module.exports = __webpack_public_path__ + "img/Billionaire-4.ffdf95c1.gif";